import { Heading } from 'blaze-ui/Heading/Heading'
import { Input } from 'almanac-ui/TextInputField/Input'
import { useField } from 'formik'
import { FormInputProps } from './Types'
import Styles from './CreateCampaign.module.scss'

export const ThemeInput = ({ name }: FormInputProps) => {
  const [field, meta, helpers] = useField<string>(name)

  return (
    <label className={Styles.label}>
      <Heading level={4}>What's your campaign about?</Heading>
      <Input
        name={name}
        placeholder="Enter a theme or topic"
        autoFocus
        isTextarea
        value={field.value}
        onChange={(e) => helpers.setValue(e.target.value)}
        isValid={!meta.touched || !meta.error}
        errorMessage={meta.touched && meta.error}
      />
    </label>
  )
}
